import React from "react";

const CourseCard = ()=>{
    return(
        <div>
            
        </div>
    )
}

export default CourseCard